import React from 'react';
import { Flex, Text, Box } from '@chakra-ui/react';
import { Modal, useToast, Button } from '@morressier/alembic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExport } from '@fortawesome/pro-light-svg-icons';
import { useExportSubmission } from '../../api/commands';
import { useSubmissionData } from '../../contexts/SubmissionDataProvider';
import { IExportSubmissionCommand } from '@publishing-engine/domain/actions/v1';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  isLoading: boolean;
  submissionId: string;  
  submissionContextId?: string;
  chooseMessage?: (msg: string) => void; // Optional prop for message handling
  phaseName: IExportSubmissionCommand["targetPhase"];
}

const ExportSubmissionModal: React.FC<Props> = props => {  
   const {
      isOpen,
      onClose,
    //   onExport,
      isLoading,
      submissionId,
      phaseName
    } = props;
    const toast = useToast();
    const {
      fieldsResponse: { organizationId, submissionContextId }
    } = useSubmissionData();
  
    const createExportSubmission = useExportSubmission({  
      queryKey: ['submission-notes', { submissionId }],  
      submissionId,
      submissionContextId,
      organizationId,
      phaseName
    });
  
    const handleExportResponse = async () => {
      const response = await createExportSubmission.mutateAsync();
      if (response.isSuccess) {
        toast({
          variant: 'success',
          title: 'Submission Export Initiated',
          description: `Once your data export is complete, we will send you an email with a download link.`
        });
        onClose(); 
      } else {
        toast({
          variant: 'error',
          title: response.message
        });  
      }
    };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      width="45rem"
      closeButtonProps={{
        hidden: true
      }}
    >
        <Flex flexDirection="column" gap={6} padding={8}>
          <Box>
            <FontAwesomeIcon fontSize={32} icon={faFileExport} />
          </Box>
          <Flex flexDirection="column" gap={2}>
            <Flex alignItems="center">
              <Text textStyle="headingGroup">Before You Export</Text>
            </Flex>
            {phaseName === 'formalAcceptance' ? (
                <>
                  <Text textStyle="textBody">                  
                    This export is a formal acceptance export. All submission data will be packaged into a .zip file and emailed to you once it is ready.
                  </Text>
                </>
              ) : (
                <>
                  <Text textStyle="textBody">
                    This export won't be sent to the production system, as this will only happen once the submission moves to Formal Acceptance. 
                  </Text>
                  <Text textStyle="textBody">
                    Instead, all submission data will be packaged into a .zip file, and emailed to you once it's ready.
                  </Text>
                </>
              )}    
          </Flex>

          <Flex flexDirection="row" gap={2} justifyContent="end">
            <Button variant="secondary"
              onClick={() => {
                onClose();
              }}
              isDisabled={isLoading}
            >
              Close
            </Button>
            <Button
              variant="primary"
              onClick={handleExportResponse}
            >
              Export
            </Button>
          </Flex>
        </Flex>
    </Modal>
  );
};

export default ExportSubmissionModal;
